import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MediaMatcher} from "@angular/cdk/layout";
import {AuthService} from "../../shared/services/auth.service";
import {Subscription} from 'rxjs/Subscription';
import {MatSidenav} from '@angular/material';


@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html'
})
export class FullLayoutComponent implements  AfterViewInit, OnDestroy{
  @ViewChild('sidenav') sidenav: MatSidenav;
  public userType: string;
  private subscription: Subscription;
  constructor(private changeDetectorRef: ChangeDetectorRef, private media: MediaMatcher, private authService: AuthService) {
    this.subscription = this.authService.getUserType().subscribe(type => {this.userType = type; } );
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.sidenav.open('program');
    },330);

  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  signOut() {
    this.authService.signOut();
  }
}




// WEBPACK FOOTER //
// C:/Users/bruna/Desktop/nuresp/src/app/containers/full-layout/full-layout.component.ts